export default __webpack_public_path__ + "static/media/faq.573930fb.svg";